export default {
  'EditProfileNavbar.overview': { en: 'OVERVIEW', fr: 'APERÇU' },
  'EditProfileNavbar.audio': { en: 'AUDIO', fr: "L'AUDIO" },
  'EditProfileNavbar.videos': { en: 'VIDEOS', fr: 'VIDÉOS' },
  'EditProfileNavbar.gallery': { en: 'GALLERY', fr: 'GALERIE' },
  'EditProfileNavbar.pricing': { en: 'PRICING', fr: 'Prix' },
  'EditProfileNavbar.acts': { en: 'ACTS', fr: 'ACTES' },
};
